import { combineReducers } from "@reduxjs/toolkit";

import {
	archivesMessagesHistoryDataState,
	archivesMessagesHistoryDataReducer,
	archivesMessagesHistoryDataAction,
} from "./data";

export type StateMessagesHistory = {
	data: archivesMessagesHistoryDataState;
};

export const messagesHistory = combineReducers<StateMessagesHistory>({
	data: archivesMessagesHistoryDataReducer,
});

export const archivesMessagesHistoryAction = {
	data: archivesMessagesHistoryDataAction,
};

export default messagesHistory;
